//#region IMPORT
import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
/** Components Import */
import M_TCS_BASIC from './M_TCS_BASIC';
import { BottomSheetActions } from '../../../Reducer/BottomSheetReducer';
/** Query */
import { useSearch1 } from './M_TCS_BASIC_Query';
import { NavBarInfoActions } from '../../../Reducer/NavBarInfoReducer';
import dayjs from 'dayjs';
//#endregion

//#region 상수
/** 필터용 tabConfig: 부서(depCd), 년도(year), 월(month)만 표시 */
const TCS_FILTER_TAB_CONFIG = {
  parameterMapping: {
    depCd: '',
    year: '',
    month: '',
  },
};

/** 정렬 옵션: ID, 이름, 시간, 부서 */
const SORT_OPTIONS = [
  { value: 'id', label: 'ID' },
  { value: 'name', label: '이름' },
  { value: 'time', label: '시간' },
  { value: 'dep', label: '부서' },
];
//#endregion

function M_TCS_BASICF() {
  //#region 변수
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const depListFromRedux =
    useSelector((state) => state.searchInfo?.depList) ?? [];
  const depList = [{ value: '', name: '전체' }, ...depListFromRedux];

  const [workerList, setWorkerList] = useState([]);
  const [sortBy, setSortBy] = useState('');

  const searchRef = useRef({
    startDate: dayjs().subtract(3, 'year').format('YYYY-MM-DD'),
    endDate: dayjs().format('YYYY-MM-DD'),
    searchDate: dayjs().format('YYYY-MM-DD'),
    coCd: '',
    custCd: '',
    depCd: '',
    searchText: '',
    currentYear: dayjs().format('YYYY'),
    month: dayjs().format('MM'),
  });

  const sortedWorkerList = useMemo(() => {
    const list = workerList ?? [];
    const sorted = [...list].sort((a, b) => {
      if (sortBy === 'id') {
        return (a.userId || '').localeCompare(b.userId || '', 'ko');
      }
      if (sortBy === 'name') {
        return (a.name || '').localeCompare(b.name || '', 'ko');
      }
      if (sortBy === 'time') {
        const ta = Number(a.totalCumulativeHours) ?? 0;
        const tb = Number(b.totalCumulativeHours) ?? 0;
        return tb - ta;
      }
      if (sortBy === 'dep') {
        return (a.depNm || '').localeCompare(b.depNm || '', 'ko');
      }
      return 0;
    });
    return sorted;
  }, [workerList, sortBy]);
  //#endregion

  //#region useEffect
  useEffect(() => {
    dispatch(NavBarInfoActions.setType('titleBar'));
    dispatch(NavBarInfoActions.setTitleName('TBM 이수현황'));
    dispatch(NavBarInfoActions.setBgColor('#F3F7F8'));

    SearchLogic1();
    return () => {
      dispatch(BottomSheetActions.CloseBottomSheet());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  //#endregion

  //#region 쿼리
  const { runAsync: Search1Async } = useSearch1({
    onSuccess: (rows) => {
      setWorkerList(rows);
    },
  });

  const SearchLogic1 = () => {
    Search1Async({
      depCd: searchRef.current.depCd,
      currentYear: searchRef.current.currentYear,
      month: searchRef.current.month,
    });
  };
  //#endregion

  return (
    <div className="wrap h-full">
      <M_TCS_BASIC
        sortedWorkerList={sortedWorkerList}
        searchRef={searchRef}
        depList={depList}
        tabConfig={TCS_FILTER_TAB_CONFIG}
        SearchLogic1={SearchLogic1}
        sortOptions={SORT_OPTIONS}
        sortBy={sortBy}
        onChangeSort={setSortBy}
      />
    </div>
  );
}

export default M_TCS_BASICF;
